const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_healthcare-roi/artifacts/p70436tc_Emerald%20Heartbeat%20Line%20Logo%20for%20ProCliniq%20%281%29.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 py-12"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
        <div className="flex items-center gap-3">
          <div
            className="h-10 w-44 rounded-sm bg-no-repeat"
            style={{
              backgroundImage: `url(${LOGO_URL})`,
              backgroundSize: "auto 320%",
              backgroundPosition: "center 50%",
            }}
            role="img"
            aria-label="ProCliniq"
          />
          <span className="text-xs text-slate-500 tracking-[0.2em] uppercase">
            www.procliniq.co.uk
          </span>
        </div>
        <p className="text-xs text-slate-500 tracking-wide">
          © {year} ProCliniq · AI lead recovery for private health clinics.
        </p>
      </div>
    </footer>
  );
}
